import _implicitStylesheets from "./imageUploaderSlim.css";
import _implicitScopedStylesheets from "./imageUploaderSlim.scoped.css?scoped=true";
import _c360Icon from "c360/icon";
import _c360Button from "c360/button";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="file-text${0}"${2}>${"t1"}</div>`;
const $fragment2 = parseFragment`<div class="drop-area loading${0}"${2}><div class="slds-grid slds-p-horizontal_medium${0}"${2}><div class="slds-col${0}"${2}><p class="drop-text${0}"${2}>${"t4"}</p></div></div></div>`;
const $fragment3 = parseFragment`<div${"c0"}${2}>${"t1"}</div>`;
const $fragment4 = parseFragment`<div class="upload-failed-text${0}"${2}>${"t1"}</div>`;
const stc0 = {
  classMap: {
    "file-selected": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "slds-grid": true
  },
  key: 1
};
const stc2 = {
  props: {
    "iconName": "utility:file",
    "iconDescription": "file",
    "size": "x-small",
    "iconClass": "normal",
    "tabIndex": "-1"
  },
  key: 2
};
const stc3 = {
  "close-button": true
};
const stc4 = {
  classMap: {
    "slds-grid": true,
    "mouse-ignore": true
  },
  key: 9
};
const stc5 = {
  classMap: {
    "slds-p-left_xxx-small": true
  },
  key: 10
};
const stc6 = {
  "file-input": true,
  "mouse-capture": true
};
const stc7 = {
  "upload-button": true,
  "small-button": true,
  "mouse-capture": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, b: api_bind, h: api_element, ncls: api_normalize_class_name} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8, _m9, _m10, _m11, _m12} = $ctx;
  return [$cmp.previewImageUrl ? api_element("div", stc0, [api_element("div", stc1, [api_custom_element("c360-icon", _c360Icon, stc2), api_static_fragment($fragment1, 4, [api_static_part(1, null, api_dynamic_text($cmp.previewImageUrl))]), api_custom_element("c360-icon", _c360Icon, {
    classMap: stc3,
    props: {
      "iconName": "utility:close",
      "iconDescription": $cmp.sharedLabels.close,
      "size": "x-small",
      "iconClass": "normal",
      "tabIndex": "-1"
    },
    key: 5,
    on: {
      "keypress": _m0 || ($ctx._m0 = api_bind($cmp.clickDelete)),
      "click": _m1 || ($ctx._m1 = api_bind($cmp.clickDelete))
    }
  })])]) : null, !$cmp.previewImageUrl ? $cmp.isUploading ? api_static_fragment($fragment2, 7, [api_static_part(4, null, api_dynamic_text($cmp.uploadProgressLabel))]) : null : null, !$cmp.previewImageUrl ? !$cmp.isUploading ? api_element("div", {
    className: api_normalize_class_name($cmp.dropAreaClass),
    key: 8,
    on: {
      "dragenter": _m2 || ($ctx._m2 = api_bind($cmp.handleDrag)),
      "dragover": _m3 || ($ctx._m3 = api_bind($cmp.handleDrag)),
      "dragleave": _m4 || ($ctx._m4 = api_bind($cmp.handleDragLeave)),
      "drop": _m5 || ($ctx._m5 = api_bind($cmp.handleDrop)),
      "click": _m6 || ($ctx._m6 = api_bind($cmp.clickUpload))
    }
  }, [api_element("div", stc4, [api_element("div", stc5, [api_element("input", {
    classMap: stc6,
    attrs: {
      "type": "file",
      "accept": $cmp.acceptedFormats,
      "aria-label": $cmp.ariaLabel
    },
    props: {
      "value": $cmp.inputValue
    },
    key: 11,
    on: {
      "change": _m7 || ($ctx._m7 = api_bind($cmp.handleUpload))
    }
  }), api_custom_element("c360-button", _c360Button, {
    classMap: stc7,
    props: {
      "iconName": "utility:upload",
      "variant": "base",
      "label": $cmp.labels.uploadFileButtonLabel,
      "iconPosition": "left",
      "changeFocus": $cmp.handleFocus,
      "changeBlur": $cmp.handleBlur,
      "tabIndex": "-1",
      "disabled": $cmp.disabled
    },
    key: 12,
    on: {
      "click": _m8 || ($ctx._m8 = api_bind($cmp.clickUpload)),
      "dragenter": _m9 || ($ctx._m9 = api_bind($cmp.handleDrag)),
      "dragover": _m10 || ($ctx._m10 = api_bind($cmp.handleDrag)),
      "dragleave": _m11 || ($ctx._m11 = api_bind($cmp.handleDragLeave)),
      "drop": _m12 || ($ctx._m12 = api_bind($cmp.handleDrop))
    }
  })]), api_static_fragment($fragment3, 14, [api_static_part(0, {
    className: api_normalize_class_name($cmp.dropTextClass)
  }, null), api_static_part(1, null, api_dynamic_text($cmp.computedSlimDropText))])])]) : null : null, !$cmp.previewImageUrl ? !$cmp.isUploading ? $cmp.hasUploadFailed ? api_static_fragment($fragment4, 16, [api_static_part(1, null, api_dynamic_text($cmp.inlineErrorMessage))]) : null : null : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-2jp4nsen2bg";
tmpl.legacyStylesheetToken = "appx-imageUploader_imageUploaderSlim";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
